var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconePage3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.2 48",
    style: {
      enableBackground: "new 0 0 52.2 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000165951641149568794680000004923641444419409062_);}\n\t.st1{fill:#00A472;}\n\t.st2{fill:#5C3B6B;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5553",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    width: 52.2,
    height: 48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000072242038257368253290000012677436336273566623_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5553-2",
    transform: "translate(0 0)",
    style: {
      clipPath: "url(#SVGID_00000072242038257368253290000012677436336273566623_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22536",
    className: "st1",
    d: "M24.8,18.3H0.6C0.3,18.3,0,18,0,17.6c0,0,0,0,0,0v-6.9C0,10.3,0.3,10,0.6,10h24.2 c0.4,0,0.6,0.3,0.6,0.6l0,0v6.9C25.5,18,25.2,18.3,24.8,18.3L24.8,18.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22537",
    className: "st2",
    d: "M36.2,31.9h-23c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h23c0.5,0,0.9,0.4,0.9,0.9 S36.7,31.9,36.2,31.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22538",
    className: "st2",
    d: "M36.2,24.9h-23c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h23c0.5,0,0.9,0.4,0.9,0.9 S36.7,24.9,36.2,24.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22539",
    className: "st2",
    d: "M27.9,38.9H13.2c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9h14.7c0.5,0,0.9,0.4,0.9,0.9 S28.4,38.9,27.9,38.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22540",
    className: "st2",
    d: "M40,48H11c-2.9,0-5.3-2.4-5.3-5.3V5.3C5.6,2.4,8,0,11,0h30c0.5,0,0.9,0.4,0.9,0.9 s-0.4,0.9-0.9,0.9H11c-1.9,0-3.4,1.5-3.4,3.4v37.4c0,1.9,1.5,3.4,3.4,3.4H40c1.9,0,3.4-1.5,3.4-3.4V20.8c0-0.5,0.4-0.9,0.9-0.9 s0.9,0.4,0.9,0.9v21.9C45.3,45.6,43,48,40,48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22541",
    className: "st2",
    d: "M51.5,13.8H37.3c-0.3,0-0.6-0.3-0.6-0.6c0-0.3,0.3-0.6,0.6-0.6h14.3 c0.3,0,0.6,0.3,0.6,0.6C52.2,13.5,51.9,13.8,51.5,13.8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22542",
    className: "st2",
    d: "M44.4,20.9c-4.3,0-7.8-3.5-7.8-7.8c0-4.3,3.5-7.8,7.8-7.8c4.3,0,7.8,3.5,7.8,7.8 C52.2,17.4,48.7,20.9,44.4,20.9 M44.4,6.6c-3.6,0-6.5,2.9-6.5,6.5c0,3.6,2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5c0,0,0,0,0,0 C50.9,9.6,48,6.7,44.4,6.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22543",
    className: "st2",
    d: "M44.4,20.9c-2.2,0-3.4-4-3.4-7.8s1.2-7.8,3.4-7.8s3.4,4,3.4,7.8S46.6,20.9,44.4,20.9  M44.4,6.6c-0.9,0-2.2,2.5-2.2,6.5s1.3,6.5,2.2,6.5s2.2-2.5,2.2-6.5S45.3,6.6,44.4,6.6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconePage3);
export default __webpack_public_path__ + "static/media/icone-page-3.5ad0ab91290d221aede611b1fb51f5f3.svg";
export { ForwardRef as ReactComponent };